import styled from 'styled-components';
import { Flex } from 'UI';

export const SellerCard = styled(Flex)`
  width: 250px;
  max-width: 100%;
  flex: 0 0 250px;
  padding: 12px 0;
  background: ${({ theme }) => theme.color.white};
`;

export const SellerNameRow = styled(Flex)`
  width: 100%;
  margin-bottom: 16px;
  border: 1px solid ${({ theme }) => theme.color.grey85};
  border-radius: 5px;
  align-items: center;
`;
